const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Выбрать правильный план с простой и прозрачной ценой",
  monthlyUppercase: "ЕЖЕМЕСЯЧНЫЙ",
  montly: "Ежемесячный",
  free: "БЕСПЛАТНЫЙ",
  yearlyUppercase: "ЕЖЕГОДНЫЙ",
  yearly: "Ежегодный",
  inService: "В сервисе",
  buyBtn: "Купить Сейчас",
  freeTips1: "Поддерживает максимальный размер файла 20 МБ",
  freeTips2: "6 файлов в день",
  freeTips3: "Нормальная скорость обработки",
  freeTips4: "Нормальная скорость загрузки",
  freeTips5: "Убирать фон с 1 фото в день",
  freeTips52: "Убирать фон с 1 фото в день",
  freeTips6: "Доступ ко всем бесплатным инструментам",
  vipTips1: "Неограниченный размер файла",
  vipTips2: "Неограниченное количество файлов в день",
  vipTips3: "Более высокая скорость загрузки",
  vipTips4: "Более высокая скорость обработки",
  vipTips5: "Безлимитный",
  vipTips6: "Неограниченно убрать фон фото в день",
  vipTips7: "Доступ ко всем инструментам и премиум-функциям",
  vipTips8: "Продлить автоматически и отменить в любое время.",
  vipTips9: "Нет ограничений по размеру и количеству видео",
  vipTips10: "Удалить фон фото без ограничений",
  vipTips11: "Повышена скорость обработки видео и загрузки.",
  vipTips12: "Доступ ко всем бесплатным инструментам и премиальным функциям",
  acceptTitle: "Мы принимаем",
  modalTitle: "Обновите до Pro, чтобы получить доступ ко всем премиум-функциям",
  total: "Все",
  enterCode: "Ввести код",
  SignUpToPurchaseBtn: "Зарегистрироваться для покупки",
  purchaseBtn: "Перейти к покупке",
  saveTips: "Сэкономить до {{num}}%",
  discount: "Скидка",
  purchaseTips: "Подписка будет автоматически продлена, и вы можете отменить ее в любое время.",
  tips: "Примечание:",
  promoCodeInvalidTips: "Ваш промокод недействителен",
};

export default purchase;
